import { EditButton, EditButtonProps } from 'framework/ui/ui-builder';
import { useBudgetUrl } from 'domain/shared/budget';
import { ListItem } from 'framework/list';

interface EditBudgetButtonProps extends EditButtonProps {
  isVisible?: (data: ListItem) => boolean;
}

const EditBudgetButton = (props: EditBudgetButtonProps) => {
  const { getUpdateEntityUrl } = useBudgetUrl();

  return <EditButton {...props} path={getUpdateEntityUrl} />;
};

export default EditBudgetButton;
